module.exports = __webpack_public_path__ + "static/media/kisetsu-lg.99b4e6a7.png";